<script setup lang="ts">
import SingleEvent from "~/components/Redmonkey/Events/Single.vue";

const pageStore = usePageStore();

const props = defineProps({
  element: {
    type: Object,
    required: true
  }
});

const eventData = ref({});

const {data: eventsData} = await useFetch('/api/wordpress/getEvents', {
  method: "POST",
  body: {
    first: 1,
    ids: [props.element?.post_id || pageStore?.routeData?.id]
  }
})

const {events} = eventsData.value;

eventData.value = {
  ...(events?.nodes?.[0] || {}),
  settings: (props.element?.settings || {}),
  pageInfo: (events?.pageInfo || {})
}

</script>
<template>
  <SingleEvent :event="eventData"/>
</template>

<style lang="scss">
  @import "assets/css/source/components/widgets/single-event";
</style>